{
  "ozonetel": {
    "campaigns": {
      "care_calling": {
        "dummyUsers": [
          {
            "moneytorUser": "manpreet@moneytor.in",
            "dialerUser": "Agent7"
          },
          {
            "moneytorUser": "harpreet@moneytor.care",
            "dialerUser": "Agent5"
          }
        ],
        "activeUsers": [
          {
            "moneytorUser": "bobby@moneytor.care",
            "dialerUser": "Agent6"
          }
        ]
      },
      "NewMoneytorCopy": {
        "dummyUsers": [
          {
            "moneytorUser": "manpreet@moneytor.in",
            "dialerUser": "Agent7"
          }
        ],
        "activeUsers": [
          {
            "moneytorUser": "shally@skys.in",
            "dialerUser": "Agent4"
          },
          {
            "moneytorUser": "harpreet@moneytor.care",
            "dialerUser": "Agent5"
          }
        ]
      },
      "care_calling_test": {
        "dummyUsers": [
          {
            "moneytorUser": "manpreet@moneytor.in",
            "dialerUser": "Agent7"
          },
          {
            "moneytorUser": "harpreet@moneytor.care",
            "dialerUser": "Agent5"
          }
        ],
        "activeUsers": [
          {
            "moneytorUser": "bobby@moneytor.care",
            "dialerUser": "Agent6"
          }
        ]
      }
    }
  },
  "cube": {
    "campaigns": {
      "Moneytor": {
        "dummyUsers": [
          {
            "moneytorUser": "lowvalue@moneytor.in",
            "dialerUser": "dummy1"
          },
          {
            "moneytorUser": "ultralow@moneytor.in",
            "dialerUser": "dummy2"
          },
          {
            "moneytorUser": "portfolio@moneytor.in",
            "dialerUser": "dummy3"
          },
          {
            "moneytorUser": "mumbai@moneytor.in",
            "dialerUser": "Mumbai"
          },
          {
            "moneytorUser": "deepal@moneytor.care",
            "dialerUser": "Care Dummy"
          }
        ],
        "activeUsers": [
          {
            "moneytorUser": "shaurya@moneytor.care",
            "dialerUser": "Shaurya"
          },
          {
            "moneytorUser": "harpreet@moneytor.care",
            "dialerUser": "Harpreet"
          },
          {
            "moneytorUser": "manpreet@moneytor.in",
            "dialerUser": "Manpreet.K"
          }
        ]
      },
      "Moneytor_CareCalling": {
        "dummyUsers": [
          {
            "moneytorUser": "harpreet@moneytor.care",
            "dialerUser": "Harpreet"
          },
          {
            "moneytorUser": "manpreet@moneytor.in",
            "dialerUser": "Manpreet.K"
          },
          {
            "moneytorUser": "deepal@moneytor.care",
            "dialerUser": "Care Dummy"
          }
        ],
        "activeUsers": [
          {
            "moneytorUser": "bobby@moneytor.care",
            "dialerUser": "Bobby"
          }
        ]
      },
      "high_value_P7_P8": {
        "dummyUsers": [
          {
            "moneytorUser": "ultralow@moneytor.in",
            "dialerUser": "dummy2"
          },
          {
            "moneytorUser": "portfolio@moneytor.in",
            "dialerUser": "dummy3"
          },
          {
            "moneytorUser": "mumbai@moneytor.in",
            "dialerUser": "Mumbai"
          }
        ],
        "activeUsers": [
          {
            "moneytorUser": "lowvalue@moneytor.in",
            "dialerUser": "dummy1"
          }
        ]
      }
    }
  },
  "centro": {
    "campaigns": {
      "TESTING": {
        "dummyUsers": [
          {
            "moneytorUser": "",
            "dialerUser": ""
          }
        ],
        "activeUsers": [
          {
            "moneytorUser": "",
            "dialerUser": ""
          }
        ]
      }
    }
  }
}